const WAIT_MS = 2000;
const POLL_MS = 100;

const readCert = () =>
	document.querySelector('[name="xxTrustedFormCertUrl"]')?.value?.trim() || "";

/**
 * TrustedForm loads asynchronously, so a fast submit can get here before the certificate exists.
 * Resolves with an empty string if there isn't one, so a blocked script never stops the visitor.
 */
export async function waitForTrustedFormCert() {
	let cert = readCert();
	if (cert || !document.querySelector('script[src*="cdn.trustedform.com"]')) return cert;

	const deadline = Date.now() + WAIT_MS;
	while (!cert && Date.now() < deadline) {
		await new Promise((resolve) => setTimeout(resolve, POLL_MS));
		cert = readCert();
	}
	return cert;
}
